import useSWR from 'swr';

const fetchLink = async (url) => {
    const rsp = await fetch(url);

    if (!rsp.ok) {
        const error = new Error("Request failed");
        error.status = rsp.status;
        error.info = await rsp.text().catch(() => null);
        throw error;
        }
    if (rsp.ok) {
        return rsp.json();
        }
    }

const useBadgeLink = (owner, repo) => {

    const shouldRetryOnError =(error) =>{
        return error.status != 403;
        }

    return useSWR(`/api/badgeLink/${owner}/${repo}`, fetchLink, {shouldRetryOnError});
    }

export default useBadgeLink;